export default __webpack_public_path__ + "static/media/rednBlue360.297c0719.gif";